import { useRouter } from 'next/router';
import React from 'react';

import type { NavGroupItem, NavItem, NavItemInternal } from 'types/client/navigation';

interface ReturnType {
  mainNavItems: Array<NavItem | NavGroupItem>;
  accountNavItems: Array<NavItem>;
}

export function isGroupItem(item: NavItem | NavGroupItem): item is NavGroupItem {
  return 'subItems' in item;
}

export function isInternalItem(item: NavItem): item is NavItemInternal {
  return 'nextRoute' in item;
}

export default function useNavItems(): ReturnType {
  const { pathname } = useRouter();

  return React.useMemo(() => ({
    mainNavItems: [
      {
        text: 'خانه',
        nextRoute: { pathname: '/' as const },
        icon: 'explorer',
        isActive: pathname === '/',
      },
      {
        text: 'پروژه‌ها',
        nextRoute: { pathname: '/projects' as const },
        icon: 'contracts/verified',
        isActive: pathname === '/projects',
      },
      {
        text: 'همه توکن‌ها',
        nextRoute: { pathname: '/tokens' as const },
        icon: 'token',
        isActive: pathname === '/tokens' || pathname.startsWith('/token/'),
      },
      {
        text: 'همه قراردادها',
        nextRoute: { pathname: '/verified-contracts' as const },
        icon: 'contracts/verified_many',
        isActive: pathname === '/verified-contracts',
      },
      {
        text: 'تراکنش‌ها',
        nextRoute: { pathname: '/txs' as const },
        icon: 'transactions',
        isActive: pathname === '/txs' || pathname === '/tx/[hash]',
      },
      {
        text: 'بلاک‌ها',
        nextRoute: { pathname: '/blocks' as const },
        icon: 'block',
        isActive: pathname === '/blocks' || pathname === '/block/[height_or_hash]',
      },
    ],
    accountNavItems: [],
  }), [ pathname ]);
}
